import { render, staticRenderFns } from "./sub-icon-primary.vue?vue&type=template&id=3065b634&scoped=true"
import script from "./sub-icon-primary.vue?vue&type=script&lang=js"
export * from "./sub-icon-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3065b634",
  null
  
)

export default component.exports